<template>
  <div
    class="ws-state-relationship-select"
    :class="[{'round':round},{active:menuActive},{'is-error':errors&&errors.length},{'is-disabled':_disabled}]"
    v-click-outside="$_onClickOutside"
  >
    <a
      href="#"
      @click.prevent="$_onOpenClick()"
      class="ws-state-relationship-select__button"
      ref="wsStateRelationshipSelectButton"
    >
      <div
        v-if="_hasValue"
        class="ws-state-relationship-select__button-text"
      >{{_valueText}}</div>
      <div
        v-else
        class="ws-state-relationship-select__placeholder"
      >{{placeholder}}</div>
      <v-icon
        v-if="clearable && _hasValue && JSON.stringify(value) !== '{}'"
        class="icon text-body-1"
        @click.stop.prevent="$_onClearClick()"
      >mdi-close-circle-outline</v-icon>
      <v-icon class="icon">mdi-menu-down</v-icon>
    </a>
    <WsChipList
      v-if="_chipList && _chipList.length > 0"
      class="mt-1"
      :chipList="_chipList"
      :textColor="closeChipTextColor"
      :borderColor="closeChipBorderColor"
      :backgroundColor="closeChipBackgroundColor"
      @chip-close="$_chipCloseClick($event)"
    ></WsChipList>
    <div
      v-if="menuActive"
      class="ws-state-relationship-select__menu"
      :class="{top: _menuTopPosition}"
    >
      <div
        class="ws-state-relationship-select__search-input-section"
        v-if="!hasNoSearch"
      >
        <div class="ws-state-relationship-select__search-input">
          <v-icon class="icon">mdi-magnify</v-icon>
          <input
            ref="searchInput"
            type="text"
            v-model="searching"
          >
          <a
            @click.prevent="$_onInputClearClick()"
            class="search-input-clear-button"
          >
            <v-icon class="clear-icon">mdi-close-circle</v-icon>
          </a>
        </div>
      </div>
      <div
        class="ws-state-multiple-layer-select__select-section"
        v-if="multiple && hasAllSelectBtn"
      >
        <a
          @click="$_selectAll()"
          class="ws-state-multiple-layer-select__select-btn"
        >
          <v-icon class="select-icon">{{_allBtnIcon}}</v-icon> 全選
        </a>
      </div>
      <div
        v-if="loading"
        class="loading-section"
      >
        <v-progress-circular
          v-if="loading"
          size="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div
        v-else-if="_items.length"
        class="ws-state-relationship-select__options"
        @scroll="$_getOptionsPosition()"
      >
        <a
          v-for="(item,itemIndex) in _items"
          :key="itemIndex"
          href="#"
          @click.prevent="$_onOptionClick(item)"
          :class="{active:$_activeCheck(item)}"
        >
          <div
            v-show="multiple"
            class="checkbox"
          >
            <v-icon v-if="$_activeCheck(item)">mdi-checkbox-marked</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </div>
          <p>{{item.text}}</p>
        </a>
      </div>
      <div
        v-else
        class="no-result-text"
      >
        <p v-if="searching">找不到 ”{{searching}}” 相關搜尋結果</p>
        <p v-else>無選項</p>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  data: () => ({
    firstScroll: false,
    page: 1,
    totalPage: 1,
    searching: "",
    menuActive: false,
    modelDatas: [],
    fetchedItems: [],
    loading: false,
    searchTimeout: null,
    selectButttonPositionY: 0,
    window: {
      width: 0,
      height: 0,
    },
    scrollOptionsPosition: 0,
    closeChipList: [],
    closeChipBackgroundColor: "#f7fafc",
    closeChipTextColor: "#353e4d",
    closeChipBorderColor: "#d7dee7",
    isOriginValue: false,
    oldParentState: [],
    conditionsValueLength: 0,
  }),
  methods: {
    $_onClearClick() {
      this.$emit("input", null);
    },
    $_chipCloseClick($event) {
      const item = $event;
      const _value = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
      const itemIndex = _value.findIndex((e) => {
        return e == item.value;
      });
      if (itemIndex >= 0) {
        _value.splice(itemIndex, 1);
      }
      this.$emit("input", _value);
      this.$_removeCloseList(item);
    },
    $_removeCloseList(item) {
      const _value = this.closeChipList
        ? JSON.parse(JSON.stringify(this.closeChipList))
        : [];
      const itemIndex = _value.findIndex((e) => {
        return e.value == item.value;
      });
      if (itemIndex >= 0) {
        _value.splice(itemIndex, 1);
      }
      this.closeChipList = _value;
    },
    $_getOptionsPosition() {
      this.$_itemsFetch("scroll");
    },
    $_activeCheck(item) {
      if (!this.value) {
        return;
      }
      if (this.multiple) {
        return this.value.includes(item.value);
      } else {
        return this.value == item.value;
      }
    },
    $_originValueToFetchedItems() {
      if (!this.originValue) {
        return;
      }
      this.fetchedItems = [];
      if (this.multiple) {
        this.originValue.forEach((originValueItem) => {
          const text = this.getText
            ? this.getText(originValueItem)
            : originValueItem[this.textKey];
          this.fetchedItems.push({
            value: originValueItem[this.valueKey],
            text: text,
          });
          this.closeChipList = [...this.fetchedItems];
        });
        this.isOriginValue = true;
      } else {
        const text = this.getText
          ? this.getText(this.originValue)
          : this.originValue[this.textKey];
        this.fetchedItems.push({
          value: this.originValue[this.valueKey],
          text: text,
        });
        this.closeChipList = [...this.fetchedItems];
        this.isOriginValue = true;
      }
    },
    $_fetchPrepare() {
      this.loading = true;
      this.modelDatas = [];
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$_itemsFetch();
      }, 500);
    },
    $_onInputClearClick() {
      this.searching = "";
      setTimeout(() => {
        if (!this.$refs.searchInput) return;
        this.$refs.searchInput.focus();
      }, 0);
    },
    $_onOptionClick(item) {
      if (this.noReset && this.hasCloseChips) {
        const allValue = this.closeChipList.map((select) => select.value);
        if (!allValue.includes(item.value)) {
          this.closeChipList.push(item);
        } else {
          this.$_removeCloseList(item);
        }
      }
      if (this.multiple) {
        const _value = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
        const itemIndex = _value.findIndex((e) => {
          return e == item.value;
        });
        if (itemIndex >= 0) {
          _value.splice(itemIndex, 1);
        } else {
          _value.push(item.value);
        }
        this.$emit("input", _value);
      } else {
        this.$emit("input", item.value);
        this.menuActive = false;
      }
    },
    $_onClickOutside() {
      this.menuActive = false;
    },
    $_onOpenClick() {
      if (this._disabled) return;
      this.$_getSelectButtonPositionY();
      this.menuActive = !this.menuActive;
      if (this.menuActive) {
        this.$_itemsFetch();
        this.$_handleResize();
        setTimeout(() => {
          if (!this.$refs.searchInput) return;
          this.$refs.searchInput.focus();
        }, 0);
      }
    },
    async $_itemsFetch(type) {
      if (type === "scroll") {
        this.loading = false;
        if (this.page >= this.totalPage) {
          return;
        }
      } else {
        this.loading = true;
      }
      const targetState = Array.isArray(this.parentState) ? this.parentState[0] : this.parentState;
      const parenState = targetState?.id ?? targetState ?? '';
      let getUrl =
        parenState && this.parent
          ? `/${this.parent}/${parenState}/${this.modelName}`
          : `/${this.modelName}`;
      const params = {
        search: this.searching,
      };
      if (type === "scroll") {
        if (!this.firstScroll) {
          this.page = 1;
        } else {
          this.page++;
        }
        params.page = this.page;
      }
      if (this.excludeSelf) {
        const excludeIds = [this.modelId];
        params.excludes = excludeIds.join(",");
      }
      if (this.orderWay) {
        params.order_way = this.orderWay;
      }
      if (this.orderBy) {
        params.order_by = this.orderBy;
      }
      if (this.conditions) {
        this.conditions.forEach((condition) => {
          if (
            condition.type &&
            condition.type == "array" &&
            condition.value &&
            Array.isArray(condition.value)
          ) {
            let conditionValue = "";
            condition.value.forEach((_value) => {
              if (typeof _value === "object") {
                conditionValue += `${_value.id},`;
              } else {
                conditionValue += `${_value},`;
              }
            });
            params[condition.key] = conditionValue;
          } else {
            params[condition.key] = condition.value;
          }
        });
      }
      try {
        const res = await this.$axios.get(getUrl, {
          params: params,
        });
        if (type === "scroll") {
          this.modelDatas = [...this.modelDatas, ...res.data.data];
        } else {
          this.modelDatas = res.data.data;
        }
        if (type !== "scroll") {
          this.page = 1;
        }
        this.firstScroll = true;
        if (res.data.meta) {
          this.totalPage = res.data.meta.last_page;
        }
        this.$_fetchedItemsSet();
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    $_fetchedItemsSet() {
      this._items.forEach((item) => {
        const tarIndex = this.fetchedItems.findIndex((e) => {
          return e.value == item.value && e.text == item.text;
        });
        if (tarIndex < 0) {
          this.fetchedItems.push(item);
        }
      });
    },
    valueReset() {
      this.$emit("input", null);
    },
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_getSelectButtonPositionY() {
      if (!this.$refs.wsStateRelationshipSelectButton) return;
      const selectButton =
        this.$refs.wsStateRelationshipSelectButton.getBoundingClientRect();
      this.selectButttonPositionY = selectButton.y;
    },
    $_selectAll() {
      const allArr = [];
      const allValue = [];
      this._items.forEach((item) => {
        allValue.push(item);
      });
      if (!this.value || this.value.length < allValue.length) {
        this._items.forEach((firstLayer) => {
          allArr.push(firstLayer.value);
        });
      }
      this.$emit("input", allArr);
      this.$emit("click");
    },
    async $_updateSelected() {
      if (this.parentState && typeof this.parentState === "object") {
        if (this.parentState.length === 0) {
          this.valueReset();
        } else if (this.parentState.length < this.oldParentState.length) {
          this.modelDatas.forEach((modelDataItem) => {
            let parentStateId = "";
            if (this.parentStateName) {
              parentStateId = modelDataItem[this.parentStateName].id;
            } else {
              parentStateId = modelDataItem[this.conditions[0].key].id;
            }
            if (
              this.value.find((findItem) => {
                return modelDataItem.id == findItem;
              })
            ) {
              if (
                !this.parentState.find((findItem) => {
                  return findItem === parentStateId;
                })
              ) {
                let deleteIndex = this.value.findIndex((e) => {
                  return e === modelDataItem.id;
                });
                this.value.splice(deleteIndex, 1);
              }
            }
          });
        }
        this.oldParentState = this.parentState;
      } else {
        this.valueReset();
      }
    },
  },
  computed: {
    _hasValue() {
      if (this.multiple) {
        return this.value && this.value.length > 0;
      } else {
        return this.value;
      }
    },
    _allBtnIcon() {
      const allValue = [];
      this._items.forEach((item) => {
        allValue.push(item);
      });
      if (
        this.value &&
        this.value.length < allValue.length &&
        this.value.length > 0
      ) {
        return "mdi-minus-box";
      } else if (!this.value || this.value.length === 0) {
        return "mdi-checkbox-blank-outline";
      } else {
        return "mdi-checkbox-marked";
      }
    },
    _disabled() {
      if (this.parent && !this.parentState) {
        return true;
      } else if (
        this.requiredField &&
        (!this.requiredFieldState || this.requiredFieldState.length == 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
    _valueText() {
      if (!this.value) {
        return null;
      } else {
        if (this.multiple) {
          let _valueText = "";
          this.value.forEach((valueItem) => {
            const tarItem = this.fetchedItems.find((e) => {
              return e.value == valueItem;
            });
            if (tarItem) {
              if (_valueText) {
                _valueText += `, ${tarItem.text}`;
              } else {
                _valueText += tarItem.text;
              }
            }
          });
          return _valueText;
        } else {
          const tarItem = this.fetchedItems.find((e) => {
            return e.value == this.value;
          });
          if (!tarItem) {
            return null;
          } else {
            return tarItem.text;
          }
        }
      }
    },
    _items() {
      const _items = [];
      this.modelDatas.forEach((modelData) => {
        let text;
        if (this.getText) {
          text = this.getText(modelData);
        } else {
          text = this.$_CMS_getValueByFieldKey(this.textKey, modelData);
        }
        if (this.getValue) {
          _items.push({
            value: this.getValue(modelData),
            text: text,
          });
        } else {
          _items.push({
            value: modelData[this.valueKey],
            text: text,
          });
        }
      });
      return _items;
    },
    _menuTopPosition() {
      if (this.window.height - this.selectButttonPositionY < 360) {
        return true;
      } else {
        return false;
      }
    },
    _chipList() {
      if (!this.hasCloseChips || !this.value) return;
      let newArray = [];
      this.fetchedItems.forEach((item) => {
        if (this.value.includes(item.value)) {
          newArray.push(item);
        }
      });
      return newArray;
    },
    _valueItemsFromFetchedItems() {
      if (!this.value || !this.value.length || !this.fetchedItems || !this.fetchedItems.length) return [];
      const fetchedItemMap = new Map(this.fetchedItems.map(item => [item.value, item]));
      return this.multiple
        ? this.value.map(id => fetchedItemMap.get(id)).filter(item => item !== undefined)
        : fetchedItemMap.get(this.value) || null;
    }
  },
  props: {
    modelId: {
      type: [Number, String],
      default: null,
    },
    excludeSelf: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: null,
    },
    note: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    getText: {
      type: Function,
      default: null,
    },
    getValue: {
      type: Function,
      default: null,
    },
    conditions: {
      type: Array,
      default: null,
    },
    requiredField: {
      default: null,
    },
    requiredFieldState: {
      default: null,
    },
    parentState: {
      default: null,
    },
    parent: {
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    round: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "select",
    },
    originValue: {},
    value: {},
    textKey: {
      type: String,
      default: "name",
    },
    valueKey: {
      type: String,
      default: "id",
    },
    orderWay: {
      type: String,
      default: "",
    },
    orderBy: {
      type: String,
      default: "",
    },
    hasNoSearch: {
      type: Boolean,
      default: false,
    },
    hasAllSelectBtn: {
      type: Boolean,
      default: false,
    },
    noReset: {
      type: Boolean,
      default: false,
    },
    hasCloseChips: {
      type: Boolean,
      default: false,
    },
    parentStateName: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    searching: {
      handler() {
        this.$_fetchPrepare();
      },
    },
    parentState: {
      handler() {
        if (this.noReset) return;
        this.$_updateSelected();
      },
    },
    originValue: {
      handler() {
        this.$_originValueToFetchedItems();
        this.$_fetchedItemsSet();
      },
    },
    conditions: {
      handler() {
        if (
          this.conditionsValueLength &&
          this.conditions[0].value &&
          this.conditions[0].value.length < this.conditionsValueLength
        ) {
          this.$emit("input", []);
          this.conditionsValueLength = 0;
        } else if (this.conditionsValueLength) {
          this.conditionsValueLength = this.conditions[0].value.length;
        }
      },
      deep: true,
    },
    _valueItemsFromFetchedItems() {
      this.$emit('input-item', this._valueItemsFromFetchedItems);
    }
  },
  directives: {
    ClickOutside,
  },
  mounted() {
    this.$_originValueToFetchedItems();
    this.$_handleResize();
    this.$_itemsFetch();
    if (this.parentState) {
      this.oldParentState = this.parentState;
    }
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-state-relationship-select.scss";
</style>